<template>
	<n-card
		style="max-width: 450px; min-width: 260px"
		title="Создание пользователя"
		:bordered="false"
		size="huge"
		role="dialog"
		aria-modal="true"
	>
		<n-form v-if="state.user.authtoken === null">
			<n-form-item label="Логин">
				<n-input v-model:value="state.user.login"
					type="text"
					placeholder="" />
			</n-form-item>
			<n-space justify="space-between">
				<n-button @click="emit('modalclose')">
					Отмена
				</n-button>
				<n-button type="success"
					@click="createUser">
					Создать
				</n-button>
			</n-space>
		</n-form>
		<n-form v-else>
			<n-form-item label="Ссылка для входа (нажмите чтобы скопировать)">
				<n-input v-model:value="state.user.authtoken"
					disabled
					@click="clipboard(state.user.authtoken)"/>
			</n-form-item>
			<n-space justify="space-between">
				<n-button @click="emit('modalclose')">
					Закрыть
				</n-button>
				<n-button type="success"
					@click="state.user.login = ''; state.user.authtoken = null">
					Создать нового пользователя
				</n-button>
			</n-space>

		</n-form>
	</n-card>
</template>

<script setup>

import { reactive, defineEmits } from "vue"
import { useMessage } from "naive-ui"
import { useStore } from "vuex"

const emit = defineEmits(["modalclose"])

const message = useMessage()
const store = useStore()
const clipboard = async (text) => {
	await navigator.clipboard.writeText(text)
	message.info("Ссылка скопирована")
}

const state = reactive({
	user: {
		login: "",
		authtoken: null,
	}

})


const createUser = async() => {
	const response = await fetch(`${store.state.backend}/users/user`, {
		method: "PUT",
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify({
			"token": store.state.admin.token,
			"login": state.user.login
		})
	})
	if (response.ok) {
		const data = await response.json()
		state.user.authtoken = `${document.location.origin}/login?token=${data.auth_token}`
	} else {
		try {
			const data = await response.json()
			message.error(`Ошибка при попытке создать пользователя: \n ${data.reason}`)
		} catch {
			message.error("Ошибка при попытке создать пользователя")
		}
	}
}

</script>